import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-left">
                © {new Date().getFullYear()}{' '}
                <a
                    href="https://sdainfosys.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#fff   ', textDecoration: 'none' }}
                >
                    SDA Infosys
                </a>. All rights reserved.
            </div>


            <div className="footer-center">
                <a href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                <span>|</span>
                <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </div>

            <div className="footer-right">
                Contact: <a href="mailto:support@sdainfosys.com">support@sdainfosys.com</a>
            </div>
        </footer>
    );
}

export default Footer;
